/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  enlarge: {
    width: 16,
    height: 16,
    viewBox: '0 0 352.054 352.054',
    data:
      '<path pid="0" d="M144.206 186.634L30 300.84v-62.781H0v113.995h113.995v-30H51.212l114.207-114.207zM238.059 0v30h62.781L186.633 144.208l21.213 21.212L322.054 51.213v62.782h30V0z"/>'
  }
})
